/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../../../../styles/colors';
import { typography, fontWeights } from '../../../../../../styles/typography';
import { MediaQueries } from '../../../../../../styles/Grid';

export const solutionsSection = css({
  padding: '0 24px',

  [MediaQueries.md]: {
    padding: '0 40px',
  },

  [MediaQueries.lgAndUp]: {
    padding: 0,
  },
});

export const modalHeadline = css(typography.effra58Modal, {
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  fontWeight: fontWeights.medium,
  marginBottom: 24,
  paddingBottom: 24,
  paddingTop: 64,

  [MediaQueries.mdAndUp]: {
    marginBottom: 40,
  },

  [MediaQueries.lgAndUp]: {
    display: 'none',
  },
});

export const solutionsList = css({
  marginLeft: 21,

  [MediaQueries.mdAndUp]: {
    marginLeft: 0,
  },

  [MediaQueries.lgAndUp]: {
    marginTop: 12,
  },
});
